import React, { useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { ChevronLeft } from 'lucide-react';
import Step1 from './Step1';
import Step2 from './step2/Step2';
import Step3 from './Step3';
import Step4 from './step4/Step4';
import {
  ExtractionsProvider,
  useExtractionContext,
} from '../../contexts/extractions/ExtractionContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getColumnListValues, loadCustomColumnOptions, loadExtraction, loadExtPageData } from '../../store/extractions/action';
import { useDispatch } from 'react-redux';
import AddCustomColumns from './step3/AddCustomColumns';
import { ExtCustomColumnsProvider } from '../../contexts/extractions/ExtCustomColumnContext';
import { ExtCustomColumnQueriesProvider } from '../../contexts/extractions/ExtCustomColumnQueryContext';
import ExtractionLayout from './ExtractionLayout';
// import Step5 from './step5/Step5';

const ExtractionContent = () => {
  const { key } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    stepVal,
    extractionData,
    currentSubStep,
    canGoNext,
    canGoPrevious,
    isLastStep,
    handleNext,
    handlePrevious,
    handleReset,
    setStep,
  } = useExtractionContext();

  const isViewMode = location.pathname.includes('/extraction/view');

  const renderStepContent = () => {
    switch (stepVal) {
      case 1:
        return <Step1 />;
      case 2:
        return <Step2 currentSubStep={currentSubStep} />;
      case 3:
        return <Step3 />;
      case 4:
        return <Step4 />;
      // case 5:
      //   return <Step5 />;
      default:
        return <div>Step not found</div>;
    }
  };

  useEffect(() => {
    if (!key && !isViewMode) {
      handleReset();
    }

    if (key && !extractionData.id && !isViewMode) {
      dispatch(loadExtraction({ key, navigate }));
    }
  }, [key, isViewMode, extractionData.id, dispatch, navigate, handleReset]);

  useEffect(() => {
    if (stepVal === 1 && !isViewMode && !extractionData.id) {
      dispatch(loadExtPageData());
    }

    if (stepVal === 3 && !isViewMode) {
      dispatch(getColumnListValues());
      dispatch(loadCustomColumnOptions());
    }
  }, [stepVal, dispatch, isViewMode, extractionData.id]);

  
  // Set step to 4 when in view mode
  useEffect(() => {
    if (isViewMode) {
      setStep(4);
    }
  }, [isViewMode, setStep]);

  return (
    <ExtCustomColumnsProvider>
      <ExtCustomColumnQueriesProvider>
        <ExtractionLayout>
          {/* Step Content */}
          {renderStepContent()}

          {/* Action Buttons - Hide in view mode */}
          {!isViewMode && (
            <div className="flex justify-between items-center mt-8">
              <div>
                {canGoPrevious && (
                  <Button variant="outline" onClick={handlePrevious}>
                    <ChevronLeft className="h-4 w-4 mr-2" />
                    Previous
                  </Button>
                )}
              </div>

              <div className="flex gap-3">
                {stepVal === 1 && (
                  <Button variant="outline" onClick={handleReset}>
                    Reset
                  </Button>
                )}

                {!isLastStep ? (
                  stepVal !== 4 && (
                    <Button onClick={handleNext} disabled={!canGoNext}>
                      Next
                    </Button>
                  )
                ) : (
                  <Button
                    onClick={() => console.log('Submitting...', extractionData)}
                  >
                    Submit
                  </Button>
                )}

              </div>
            </div>
          )}

          {!isViewMode && <AddCustomColumns />}
        </ExtractionLayout>
      </ExtCustomColumnQueriesProvider>
    </ExtCustomColumnsProvider>
  );
};

const Extraction = () => (
  <ExtractionsProvider>
    <ExtractionContent />
  </ExtractionsProvider>
);

export default Extraction;